import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@routes';

import { config } from '@config/config';

import { authGetIsAuthorized } from '@selectors/auth';

import { useTypedSelector } from '@hooks/store';

import { GuestGuardType } from './types';

export const GuestGuard: GuestGuardType = (props) => {
  const { children } = props;

  const isAuthorized = useTypedSelector(authGetIsAuthorized);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthorized) {
      navigate(config.defaultPath, { replace: true });
    } else {
      navigate(ROUTES.login, { replace: true });
    }
  }, [isAuthorized, navigate]);

  return children;
};
